module.exports = __webpack_public_path__ + "static/media/rrr.ff1741b1.png";